import { Navigation } from 'app/core/navigation/navigation.types';
import { CRM_MANAGER_ROLES } from 'bp/modules/crm/guards/crm-access.guard';

/**
 * Roles que abren "Traspasos" (feature 050, FR-001/FR-002): la misma jefatura del CRM
 * (`admin` + `suadvisor`). Se reusa `CRM_MANAGER_ROLES` en vez de repetir la lista, para que la
 * definición de jefatura viva en un solo lugar.
 *
 * Solo decide PRESENTACIÓN (mostrar el menú o el estado "sin permiso"): la autorización real la
 * aplica el servidor en cada RPC (`[Authorize(Roles)]` + `TransferClientPortfolio`).
 *
 * La sección NO depende del interruptor del CRM ni de `crmAccessGuard`: un traspaso de cartera
 * tiene que poder hacerse aunque el CRM esté apagado.
 */
export const CLIENT_TRANSFER_ROLES = CRM_MANAGER_ROLES;

/** Id del ítem del menú lateral (`app/mock-api/common/navigation/data.ts`). */
export const CLIENT_TRANSFER_NAV_ID = 'client-transfers';

export function canTransferClients(roles: readonly string[]): boolean {
  return roles.some(role => (CLIENT_TRANSFER_ROLES as readonly string[]).includes(role));
}

/**
 * El ítem "Traspasos" solo lo ve la jefatura. Se aplica DESPUÉS de
 * `applyCrmNavigationVisibility`, que ya lo excluye de su barrido: un usuario exclusivamente de
 * Customer Success nunca es jefatura, así que queda oculto también por esta regla.
 */
export function applyClientTransferNavigationVisibility(
  navigation: Navigation,
  canTransfer: () => boolean,
): void {
  const item = navigation.bp.find(candidate => candidate.id === CLIENT_TRANSFER_NAV_ID);
  if (item) {
    item.hidden = () => !canTransfer();
  }
}
